export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BookToday.vue?vue&type=template&id=b2af87ba&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BookToday.vue?vue&type=template&id=b2af87ba&scoped=true&
// module id = 179
// module chunks = 0